<template lang="pug">
div(style="width: 100%; height: 100%")
  .list(v-for="(l, i) in listNew", :key="i")
    //- .top-type
    //-   .type(v-show="l.type") {{ l.type }}
    .item
      .logo
        img(:src="l.imgUrl", @error="defaultImg")
      .details
        .title
          router-link.name(
            :to="{ name: 'PdfViewer', params: { id: l.id } }",
            target="_blank"
          )
            div(v-html="l.reportName")
          .tags
            .tag.brand(v-for="t in l.brands") {{ t }}
            .tag.category(v-for="t in l.categories") {{ t }}
        .context(v-html="l.introduction")
        .startTime {{ l.startTime }}

      .operation
        .operations
          button.star(
            :class="{ active: l.hasCollect }",
            @click.prevent.stop="collect(l.id, !l.hasCollect)",
            :title="`${l.hasCollect ? '取消收藏' : '收藏报告'}`"
          )
            i.fa.fa-star
          button(v-if="!l.hasBuy", title="购买报告", @click.prevent="buyReport")
            i.fa.fa-shopping-cart
          router-link(
            :to="{ name: 'EventCenter', params: { id: l.eventId } }",
            target="_blank",
            v-if="l.eventId"
          )
            button(title="案例分析")
              i.fa.fa-pie-chart
  .no-data(v-if="!listNew.length")
    data-null
</template>

<script>
import client from '../server/server'
import DataNull from '../components/DataNull'
import moment from 'moment'
export default {
  name: 'ReportViewsList',
  components: {
    DataNull
  },
  props: { lists: Array },
  data () {
    return {
    }
  },
  mounted () {
  },
  computed: {
    listNew () {
      return this.lists.map(d => {
        return Object.assign({}, d, {
          imgUrl: d.imgUrl ? this.$imgParse(d.imgUrl) : d.imgUrl,
          startTime: moment(d.startTime).format('YYYY/MM/DD'),
          categories: d.priCrisisTags && d.priCrisisTags.concat(d.secCrisisTags || [])
        })
      })
    }
  },
  watch: {
  },
  methods: {
    collect (id, boolean) {
      let data = {
        id: id,
        collect: boolean
      }
      client.changeReportCollect(data)
        .then(res => {
          if (res.success) {
            this.lists.find(d => d.id === id).hasCollect = boolean
          } else {
            return new Error(res.message)
          }
        })
    },
    defaultImg (e) {
      e.target.src = require('@index/assets/img/report_default.png')
    },
    buyReport () {
      let html = `
        <div style="text-align: center">
            <img src=${this.qrcodeUrl} style="width: 200px;height: 200px">
            <p>请联系客服购买报告</p>
        </div>
      `
      this.$alert(html, '', {
        dangerouslyUseHTMLString: true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  .top-type {
    height: 22px;
    line-height: 22px;
    margin: 4px;

    .type {
      display: inline-block;
      padding: 0 6px;
      border-radius: 2px;
      background-color: #3989cb;
      color: #fff;
      font-size: 12px;
    }
  }

  .item {
    display: flex;
    min-height: 150px;
    margin: 0 24px;
    border-bottom: 1px solid #f0f0f0;
    padding: 0 0 20px;
    align-items: center;

    .logo {
      min-width: 80px;
      margin: 20px 30px 0 10px;

      img {
        width: 80px;
        height: 80px;
        background-color: #ffffff;
        border: solid 1px #e8ebf1;
        border-radius: 50%;
        display: block;
      }
    }

    .details {
      color: #999;
      font-size: 12px;
      flex: 1;

      .title {
        display: flex;
        align-items: center;
        .name {
          color: #333;
          font-size: 14px;

          &:hover {
            cursor: pointer;
            color: #3989cb;
          }
        }
        .tags {
          margin-left: 23px;
          display: flex;
          align-items: center;

          .tag {
            margin-right: 10px;
            padding: 3px 6px;

            &.brand {
              border-radius: 2px;
              background-color: rgba(1, 83, 206, 0.2);
              color: #025fea;
            }

            &.category {
              border-radius: 2px;
              background-color: rgba(80, 179, 87, 0.2);
              color: #50b357;
            }
          }
        }
      }

      .context {
        margin-top: 15px;
      }

      .startTime {
        margin-top: 10px;
      }
    }

    .operation {
      // margin: 0 60px 0;
      min-width: 100px;
      color: #666;
      font-size: 12px;
      text-align: center;

      .operations {
        button {
          width: 26px;
          height: 26px;
          border-radius: 4px;
          border: solid 1px #e8ebf1;
          background: #fff;
          margin: 0 5px;

          i {
            color: #999;
          }

          &.star {
            &.active {
              border: solid 1px #3989cb;
              background: #3989cb;

              .fa-star {
                color: #fff;
              }
            }
          }
        }
      }
    }
  }
}

.no-data {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/ReportDownload/ReportViewsList.vue